export default {
    lan:'english',
    nav:{
        hotels:'RESORTS',
        cruisers:'CRUISERS',
        about:'ABOUT US',
        contact:'Contact Us'
    },
    aboutUs:{
        title:'We are a Mexican family business, which offers weekly accommodation packages with up to 80% discount at the best resorts in Mexico.',
        places:'Acapulco | Riviera Maya | Mazatlán | Puerto Vallarta | Nuevo Vallarta | Los Cabos | Puerto Peñasco'
    },
    component01Video :{
        title:'Hello',
        videotextpart1:'BOOK RESORT FOR A COMPLETE WEEK FOR A',
        videotextpart2:' PRICE OF ONE NIGHT !',
        videotextpart3:''
    },
    component02Cruise:{
        title:'Do not wait any longer and be among the first to enjoy the new Vidanta cruiser',
        title02:'Vidanta Cruises: Mexico’s First-Ever Luxury Cruise Line',
        topic:`INTRODUCING MEXICO'S FIRST-EVER LUXURY CRUISE LINE`,
        description:'Now you can travel and rest on board with the new cruise service available in Mexico.',
        places:['More information on itineraries, voyage length, destinations and cruising dates will be released as they are confirmed.'],
        reserve:'Request previous reservation'
    },
    form:{
        cruiser:'cruiser',
        hotel:'hotel',
        reservationInformation:{
            title:'Information of your',
            inputCity:'Which is your destination ?',
            inputRoomType:'Room type',
            roomsTypes: [
                'THE RESIDENCE ONE BEDROOM LOFT',
                'THE RESIDENCE TWO BEDROOM LOFT',
                'THE RESIDENCE THREE BEDROOM LOFT',
                'THE RESIDENCE FOUR BEDROOM',
                'GRAND LUXXE MASTER ROOM', 
                'GRAND LUXXE ONE BEDROOM SUITE', 
                'GRAND LUXXE TWO BEDROOM SUITE',
                'GRAND LUXXE JUNIOR VILLA',
                'GRAND LUXXE ONE BEDROOM VILLA',
                'GRAND LUXXE TWO BEDROOM VILLA',
                'GRAND LUXXE ONE BEDROOM PRESIDENTIAL SUITE',
                'GRAND LUXXE ONE BEDROOM PRESIDENTIAL VILLA',
                'GRAND LUXXE TWO BEDROOM PRESIDENTIAL VILLA',
                'GRAND LUXXE THREE BEDROOM PRESIDENTIAL VILLA',
                'GRAND LUXXE TWO BEDROOM SPA SUITE',
                'GRAND LUXXE THREE BEDROOM SPA SUITE',
                'GRAND LUXXE LOFT',
                'THE GRAND BLISS MASTER ROOM',
                'THE GRAND BLISS ONE BEDROOM SUITE',
                'THE GRAND BLISS TWO BEDROOM SUITE',
                'THE GRAND MAYAN MASTER ROOM',
                'THE GRAND MAYAN ONE BEDROOM SUITE',
                'THE GRAND MAYAN TWO BEDROOM SUITE',
                'MASTER ROOM DE MAYAN PALACE',
                'SUITE CON UNA RECÁMARA DE MAYAN PALACE',
                'SUITE CON DOS RECÁMARAS DE MAYAN PALACE',

            ],
            destinations:[
                'Acapulco',
                'Riviera Maya',
                'Mazatlán',
                'Puerto Vallarta',
                'Nuevo Vallarta',
                'Los Cabos',
                'Puerto Peñasco',
                'other'
            ],
            inputPersonsNumber:'Number of people ?',
            inputIncommingDate:'Arrival date',
            inputOutcommingDate:'Departure date',
        },
        userReserver:{
            title:'Responsable information',
            inputName:'Full name',
            inputPhone:'Phone number',
            inputEmail:'Email'
        },
        buttons:{
            close:'Close',
            send:'Send'
        }
    },
    footer:{
        develop:{
            title:'Developed by Connecto Software Innovations',
            subTitle:'100% Mexican Company'

        },
        follow:{
            title:'Follow us',
        }
    },    
    rooms:{
        title:'From sumptuous style to family-friendly comfort, find just the vacation experience you’re looking for from our list of refined resort hotels.',
        nightPrice:'Resort Price',
        weekPrice:'Our price',
        reserve:'Book'
    }


}
